// @flow

import { type UserInputValidationError, type UserInputValidatorArgs, onlyWhenSupport, VALID } from '@tectonics/prs/validation';
import { validateSafetypayOption } from './safetypay-option';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);


  switch (userInputName) {
    case 'selectedSafetypayOption':
      return onlyWhen('field_safetypay_select_option') && validateSafetypayOption(userInputValue);

    default:
      return VALID;
  }
}
